import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-element',
  templateUrl: './form-element.component.html',
  styleUrls: ['./form-element.component.scss'],
})
export class FormElementComponent {
  @Input({ required: true }) label: string;
  @Input() inputId: string;
  @Input() errors: string[] = [];
  @Input() description: string;
  @Input() required = true;
}
